(function () {
  const initTrustedBrands = () => {
    if (typeof Swiper === 'undefined') {
      return;
    }

    document.querySelectorAll('[data-trusted-brands]').forEach((root) => {
      const mainElement = root.querySelector('[data-trusted-brands-swiper]');

      if (!mainElement) {
        return;
      }

      if (mainElement.dataset.trustedBrandsInitialized === 'true') {
        return;
      }

      new Swiper(mainElement, {
        speed: 450,
        spaceBetween: 24,
        slidesPerView: 3,
        grabCursor: true,
        watchOverflow: true,
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 24,
          },
          1280: {
            slidesPerView: 6,
            spaceBetween: 24,
          },
        },
      });

      mainElement.dataset.trustedBrandsInitialized = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTrustedBrands);
  } else {
    initTrustedBrands();
  }

  document.addEventListener('shopify:section:load', initTrustedBrands);
})();
